import { useCheckbox } from 'react-aria';
import React, { FC, useRef } from 'react';
import { useToggleState } from 'react-stately';
import { genericMemo } from '@direct-frontend/stdlib';

import { ToggleBase } from '../ToggleBase/ToggleBase';

import { CheckboxBaseProps } from './types';

/**
 * Компонент для создания чекбоксов
 */
export const CheckboxBase: FC<CheckboxBaseProps> = genericMemo(function Checkbox(props) {
    const { size, isDisabled, isIndeterminate, children, renderBox, tabIndex } = props;

    const ref = useRef(null);
    const state = useToggleState(props);
    const { inputProps, labelProps } = useCheckbox(props, state, ref);

    return (
        <ToggleBase
            {...props}
            inputProps={inputProps}
            labelProps={labelProps}
            inputRef={ref}
            label={children}
            tabIndex={tabIndex}
        >
            {({ isFocused, isHovered }) =>
                renderBox({
                    isFocused,
                    isHovered,
                    size,
                    isChecked: state.isSelected,
                    isDisabled,
                    isIndeterminate,
                    'data-testid': props['data-testid'],
                })
            }
        </ToggleBase>
    );
});
